import React from 'react';

import ReportingContext from 'src/scenes/BusinessIntelligence/containers/Reporting/Context';
import reducer, { initialState } from 'src/scenes/BusinessIntelligence/containers/Reporting/reducer';

export const ReportingFiltersContextProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
  const value = React.useReducer(reducer, initialState);
  return <ReportingContext.Provider value={value}>{children}</ReportingContext.Provider>;
};
